import { fg } from '@atlassian/jira-feature-gating';
import { genericProjectLayout } from '@atlassian/jira-generic-project-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { ForPaintClassicSoftwareProjectSidebar as AsyncForPaintSidebarSoftwareClassic } from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createLayout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { issueNavigatorProjectClassicRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorProjectClassicRoute.tsx';
import { ProjectIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/project-app.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { getSsrCircuitBreaker } from './common/getSsrCircuitBreaker.tsx';
import { issueNavigatorPageEntryPointWithNested } from './ui/index.tsx';
import { ListRedirect } from './ui/list-redirect/ListRedirect.tsx';

/**
 * Classic Project Issue Navigator Route Entry
 * Handles Classic projects, also known as company-managed projects.
 */
export const issueNavigatorProjectClassicRouteEntry = createEntry(
	issueNavigatorProjectClassicRoute,
	() => ({
		group: 'issue-navigator',
		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},
		skeleton: ProjectIssueNavigatorSkeleton,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncForPaintSidebarSoftwareClassic,
			horizontal: AsyncHorizontalNavJira,
			sidebarId: SIDEBAR_ID.CONTENT,
		},
		resources: [
			...getCommonProjectResources({
				isUsingSidebarEntrypoint: true,
			}),
		],
		layout: createLayout(genericProjectLayout),
		isHydrateRootEnabled: fg('nin-hydrate-issue-navigator-classic'),
		bifrost: {
			bifrostGroup: 'issue-navigator',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectClassicRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorProjectClassicRouteEntry',
			},
			enabled: true,
			manifestName: 'jira-spa-issue-navigator.json',
			// An increase from 1.2s default to 1.5s will comfortably cater for P95 of issue search requests
			// For more insights into this decision, see https://jplat.atlassian.net/browse/EM-9249
			fetchTimeout: fg('increase_server_fetch_timeouts_for_nin_bifrost') ? 1500 : undefined,
			circuitBreakerConfig: getSsrCircuitBreaker(),
		},
		component: fg('jira_list_nin_merge') ? ListRedirect : undefined,
		entryPoint: () =>
			fg('jira_list_nin_merge') ? undefined : issueNavigatorPageEntryPointWithNested,
		supportsPreviewPanel: true,
	}),
);
